import { render, staticRenderFns } from "./ac-multiselect.vue?vue&type=template&id=3b10a7a2&"
import script from "./ac-multiselect.vue?vue&type=script&lang=js&"
export * from "./ac-multiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports